export default "__VITE_ASSET__afef238c__"